import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { RadioGroup, Spacer } from '@telus-uds/components-web';

import { useLocalizedStringsContext } from '../../../../../../context/LocalizedStringsContext';

const TankType = ({
  typeKey,
  dataField,
  setDataField,
  fieldOptions,
  error
}) => {
  const {
    iotOrderDetailsSection: {
      nssFarmAndRanchTankDetailsLabel: { tankType }
    },
    modalForm: { fieldRequiredMessage }
  } = useLocalizedStringsContext();

  const fieldHasError = error && !dataField.valueTankType;

  useEffect(() => {
    if (fieldOptions.length === 1 && !dataField.valueTankType) {
      setDataField(previousValue => ({
        ...previousValue,
        valueTankType: fieldOptions[0]
      }));
    }
  }, [dataField]);

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <>
    <Spacer space={4} />
      <RadioGroup
        legend={tankType}
        items={radioItems}
        checkedId={dataField.valueTankType || null}
        onChange={(value) => setDataField({
          ...dataField,
          valueTankType: value
        })}
        name={`${typeKey}--tank-type`}
        validation={fieldHasError ? 'error' : undefined}
        feedback={fieldHasError ? fieldRequiredMessage : undefined}
      />
      <Spacer space={3} />
    </>
  );
};

TankType.propTypes = {
  typeKey: PropTypes.string.isRequired,
  dataField: PropTypes.shape({
    valueTankNumber: PropTypes.string,
    valueTankName: PropTypes.string,
    valueTankProduct: PropTypes.string,
    valueTankProductOther: PropTypes.string,
    valueTankType: PropTypes.string,
    valueTankHeight: PropTypes.string,
    valueTankLength: PropTypes.string,
    valueTankCapacity: PropTypes.string,
    valueTankMaterial: PropTypes.string,
    valueTankSensorType: PropTypes.string,
    valueTankPortSize: PropTypes.string,
    valueTankOptionalStand: PropTypes.string
  }).isRequired,
  setDataField: PropTypes.func.isRequired,
  fieldOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  error: PropTypes.string.isRequired
};

export default TankType;
